import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { ExtensionRecommendations } from './extensionRecommendations.js';
import { IProductService } from 'vscode/vscode/vs/platform/product/common/productService.service';
import { PlatformToString, platform } from 'vscode/vscode/vs/base/common/platform';

let RemoteRecommendations = class RemoteRecommendations extends ExtensionRecommendations {
    get recommendations() { return this._recommendations; }
    constructor(productService) {
        super();
        this.productService = productService;
        this._recommendations = [];
    }
    async doActivate() {
        const extensionTips = { ...this.productService.remoteExtensionTips, ...this.productService.virtualWorkspaceExtensionTips };
        const currentPlatform = PlatformToString(platform);
        this._recommendations = ( ( Object.values(extensionTips)).filter(({ supportedPlatforms }) => !supportedPlatforms || supportedPlatforms.includes(currentPlatform)).map(extension => ({
            extension: extension.extensionId.toLowerCase(),
            reason: {
                reasonId: 6 ,
                reasonText: ''
            }
        })));
    }
};
RemoteRecommendations = ( __decorate([
    ( __param(0, IProductService))
], RemoteRecommendations));

export { RemoteRecommendations };
